import createTransition from 'shared-tokens/utils/createTransition';

export const mainCls = 'csa-applelogin';

export default {
  [mainCls]: {
    height: 40,
    '@media (hover: hover)': {
      transition: createTransition(['background-color']),
      '&:hover': {
        backgroundColor: '#000',
      },
    },
  },
};